import { render, staticRenderFns } from "./FooterComponentCoe.vue?vue&type=template&id=2161e085"
import script from "./FooterComponentCoe.vue?vue&type=script&lang=ts"
export * from "./FooterComponentCoe.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentCoe.vue?vue&type=style&index=0&id=2161e085&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports